import { call, delay, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { setAttrNotificacoes, triggerLoadNotificacoes, triggerMarkRead, triggerVisualizarTodas } from "./NotificacoesSlice";
import axios from "axios";

import { setLoadingFlag } from "../core/loading/LoadingSlice"
import { rpc } from "../core/rpc";

const userId = "f1ce4dbe-459d-4493-acff-96461372ba54"

function ordenada(array) {

    var n = [...array]
    n.sort((a, b) => {
        // Primeiro, comparar se a data de visualização é null
        if (a.seenAt === null && b.seenAt !== null) {
            return -1;
        }
        if (a.seenAt !== null && b.seenAt === null) {
            return 1;
        }

        // Se ambas as datas de visualização são null, comparar pela data de ocorrência
        if (a.seenAt === null && b.seenAt === null) {
            return new Date(b.occurredAt) - new Date(a.occurredAt);
        }

        // Se ambas as datas de visualização não são null, comparar pela data de ocorrência
        return new Date(b.occurredAt) - new Date(a.occurredAt);
    })

    return n
}

function* doLoadData() {
    // console.log("load data")
    yield put(setLoadingFlag({ "NOT_TELA_DATA": true }));
    yield doTheLoading()
    yield put(setLoadingFlag({ "NOT_TELA_DATA": false }));
}

function* doTheLoading() {
    var server_url = yield select((state) => state.rpc.servidorUrl)
    var token = yield select((state) => state.auth.token)

    var r = yield rpc(
        server_url,
        token,
        "NOTS_LISTA_NOTIFICACOES",
        true,
        JSON.stringify({
            userId: userId,
            qtde : 300
        }),
        null
    )

    if (r.status == 200) {
        yield put(setAttrNotificacoes({
            campo: "lista",
            value: ordenada(r.data.payload)
        }))

        yield put(setAttrNotificacoes({
            campo: "totalNaoVistas",
            value: r.data.payload.filter(e => e.seenAt == null).length
        }))
    } else {
        yield put(setAttrNotificacoes({
            campo: "error",
            value: "NAo foi possivel baixar as notificacoes"
        }))
    }


}

function* doMarkRead(action) {
    // console.log("mark read")
    yield put(setLoadingFlag({ [action.payload.tag]: true }))
    yield doTheMark(action.payload.id)
    yield doTheLoading()
    yield put(setLoadingFlag({ [action.payload.tag]: false }))
}

function* doTheMark(id) {
    var server_url = yield select((state) => state.rpc.servidorUrl)
    var token = yield select((state) => state.auth.token)

    yield rpc(
        server_url,
        token,
        "NOTS_MARCAR_NOTIFICAO_COMO_LIDA",
        true,
        JSON.stringify({
            notificacaoId: id
        })
    )
}

function* doVisualizarTodas() {
    
    yield put(setLoadingFlag({ "NOT_TELA_DATA": true }));
    var server_url = yield select((state) => state.rpc.servidorUrl)
    var token = yield select((state) => state.auth.token)

    var r = yield rpc(
        server_url,
        token,
        "NOTS_MARCAR_TODAS_NOTIFICACOES_COMO_VISUALIZADAS_RPC",
        true,
        JSON.stringify({
            userId: userId
        }),
        null
    )

    if (r.status == 200) {
        yield doTheLoading()
    } else {
        yield put(setAttrNotificacoes({
            campo: "error",
            value: "NAo foi possivel baixar as notificacoes"
        }))
    }

    
    
    yield put(setLoadingFlag({ "NOT_TELA_DATA": false }));
}

export function* listenLoadData() {
    yield takeLatest(triggerLoadNotificacoes, doLoadData)
}

export function* listenMarkRead() {
    yield takeLatest(triggerMarkRead, doMarkRead)
}

export function* listenVisualizarTodas() {
    yield takeLatest(triggerVisualizarTodas, doVisualizarTodas)
}